export var ACTION;
(function (ACTION) {
    ACTION["ONCHANGE_BANK_NAME"] = "ONCHANGE_BANK_NAME";
    ACTION["ONCHANGE_ACCOUNT_NUMBER"] = "ONCHANGE_ACCOUNT_NUMBER";
    ACTION["ONCHANGE_CONFIRM_ACCOUNT_NUMBER"] = "ONCHANGE_CONFIRM_ACCOUNT_NUMBER";
    ACTION["NAVIGATION_SEARCH_IFSC"] = "NAVIGATION_SEARCH_IFSC";
    ACTION["NAVIGATION_SEARCH_BANK"] = "NAVIGATION_SEARCH_BANK";
    ACTION["ONCHANGE_IFSC"] = "ONCHANGE_IFSC";
    ACTION["ONCHANGE_BANK_DETAILS"] = "ONCHANGE_BANK_DETAILS";
    ACTION["ONCHANGE_CONFIRMACCOUNT_NUMBER"] = "ONCHANGE_CONFIRMACCOUNT_NUMBER";
    ACTION["ONCHANGE_IFSC_DETAILS"] = "ONCHANGE_IFSC_DETAILS";
    ACTION["ONCHANGE_IFSC_NUMBER"] = "ONCHANGE_IFSC_NUMBER";
    ACTION["TRIGGER_CTA"] = "TRIGGER_CTA";
    ACTION["TOGGLE_CTA"] = "TOGGLE_CTA";
    ACTION["CHANGE_BANK_GO_BACK"] = "CHANGE_BANK_GO_BACK";
    ACTION["NAV_STEPPER"] = "NAV_STEPPER";
    ACTION["GO_NEXT"] = "GO_BACK";
    ACTION["SAVE"] = "SAVE";
    ACTION["SHARE"] = "SHARE";
    ACTION["NEXT_ROUTE"] = "NEXT_ROUTE";
    ACTION["ENABLE_CONTINUE"] = "ENABLE_CONTINUE";
    ACTION["DISABLE_CONTINUE"] = "DISABLE_CONTINUE";
})(ACTION || (ACTION = {}));
